export default class ButtonContent {
    id = null;
    elevatorId = null;
    buttonMode = 'NORMAL_MODE';
    greenButton = null;
    greenButtonName = '';
    redButton = null;
    redButtonName = '';
    carouselMedia = [];
    additionalIds = [];

    constructor() {
    }
}